import ApiClient from './ApiClient';

class PublicKnowledgeBasesAPI extends ApiClient {
  constructor() {
    super('public_knowledge_bases', { accountScoped: true });
  }
}

export default new PublicKnowledgeBasesAPI();
